import React, { Component } from 'react';
import { MdClear } from 'react-icons/md';
import { debounce } from 'lodash';
import { makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';

import { Chat, TICKET_CLOSE_STATUS } from '@qbot-chat/qbot-uikit';

import { openCloseConfirm } from '../../../../helper/consultActions';
import { COMMAND_EVENT_TYPE, CONTENT_TYPE } from '@qbot-chat/qbot-uikit/chat';

import { chatStore } from '../../../../store/FrontChatStore';
import companyStore from '../../../../store/CompanyStore';
import { COMPANY } from '../../../../const/company';
import { navigateReplace } from '../../../../helper/HistoryHelper';

import { resolveCompanyDisplay } from '../../../../helper/consultActions';

import Styles from './HyundairsChatView.module.scss';

@observer
class HyundairsChatView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  componentDidMount() {
    companyStore.fetchCompany(COMPANY.HYUNDAIRS.id);
  }

  debounceRequest = debounce((store) => this.request(store), 200, {
    leading: true,
  });

  request = async (store) => {
    let contentType = CONTENT_TYPE.TEXT;
    let message = {
      content: {
        type: contentType,
        value: COMMAND_EVENT_TYPE.AGENT_CONNECT,
      },
      contentType,
      createdAt: dayjs(),
    };
    store.onSendMessage(message);
  };

  render() {
    const { name: companyName, symbolUrl } = resolveCompanyDisplay(
      companyStore.company,
      COMPANY.HYUNDAIRS,
    );

    return (
      <div className={Styles.Container}>
        <Chat
          store={chatStore}
          isUser
          ref={chatStore.chatRef}
          renderCustomHeader={(store) => {
            return (
              <div className={Styles.HeaderContainer}>
                <div className={Styles.HeaderGradientBar} />
                <div className={Styles.Header}>
                  <div className={Styles.HeaderLeft}>
                    {!store.isRespond && (
                      <div
                        className={Styles.CloseButton}
                        onClick={() => {
                          openCloseConfirm(store);
                        }}
                      >
                        <MdClear size={20} />
                      </div>
                    )}
                    {symbolUrl && (
                      <img
                        src={symbolUrl}
                        alt={companyName}
                        className={Styles.LogoMini}
                      />
                    )}
                    <span className={Styles.BrandName}>{companyName}</span>
                  </div>
                  <div className={Styles.HeaderRight}>
                    {!store.isRespond ? (
                      <>
                        {!TICKET_CLOSE_STATUS.includes(
                          store.channel?.status,
                        ) && (
                          <button
                            className={Styles.ConnectButton}
                            onClick={() => {
                              this.debounceRequest(store);
                            }}
                          >
                            상담사 연결
                          </button>
                        )}
                      </>
                    ) : (
                      <button
                        className={Styles.EndButton}
                        onClick={() => {
                          openCloseConfirm(store);
                        }}
                      >
                        상담 종료
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          }}
          onCloseCallback={() => {
            navigateReplace(`/rating/${chatStore.channelId}`);
          }}
        />
      </div>
    );
  }
}

export default HyundairsChatView;
